import { Context } from '@vue-storefront/core';
import { ApiResult, ShopView } from '../../types';
import Cache from '../cache/cache';

export default async function shopView(ctx: Context, params: any): Promise<ApiResult> {
  const { client, config } = ctx;

  // 获取缓存
  const cacheKey = 'shopView';
  if (!params || !params.debug) {
    const cache = Cache.getCache(ctx, cacheKey);
    if (cache) {
      return cache;
    }
  }

  const url = new URL('/mall/shop/view', config.api.url);
  const { data: { data }, data: res } = await client.post(url.href);
  // console.log('## shopView ## res================', res);
  if (data && data.list) {
    const views: ShopView[] = [];
    data.list.forEach((x) => {
      const logo = x.language.split('-')[0];
      const logo1 = x.language.split('-')?.[1]?.toLowerCase();
      const store: ShopView = {
        id: x.view_id.toString(),
        name: x.name,
        logo: logo,
        logo1: logo1,
        lang: x.language,
        file: x.language + '.js',
        currency: x.currency,
        isDefault: x.is_default
      };
      views.push(store);
    });
    res.data.list = views;
  }

  // 设置缓存
  Cache.setCache(ctx, cacheKey, res);

  return res;
}
